module.exports = __webpack_public_path__ + "root-img.png?008bc8bd4cb7afe0ebe440a08ed48e49";


//////////////////
// WEBPACK FOOTER
// ./src/assets/root-img.png
// module id = 36
// module chunks = 0